/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function inview() {
	$(".inview").each(function () {
		var position = $(this).offset().top;
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll > position - windowHeight + windowHeight / 3) {
			$(this).addClass('is--inview');
		} else {
			//$(this).removeClass('is--inview');
		}
	});
}

module.exports = inview;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (str) {
	var ua = window.navigator.userAgent.toLowerCase();
	return ua.indexOf(str) !== -1;
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (videoId, hash, rate) {
    var ytPlayer = new YT.Player(hash, // 埋め込む場所をIDで設定
    {
        videoId: videoId,
        playerVars: {
            rel: 0,
            loop: 1,
            playlist: videoId,
            controls: 0,
            autoplay: 1,
            showinfo: 0,
            disablekb: 0,
            wmode: "transparent",
            modestbranding: 1,
            playerVars: {
                controls: 0, // コントロールバーを表示しない
                showinfo: 0 // 動画情報を表示しない
            }
        },
        events: {
            'onReady': function onReady(event) {
                onPlayerReady(event, hash, rate);
            }
        }
    });
};
//プレイ準備完了後
function onPlayerReady(event, hash, rate) {
    event.target.setPlaybackRate(rate);
    event.target.playVideo();
    event.target.mute();
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ua = __webpack_require__(1);
var inview = __webpack_require__(0);
var playYt = __webpack_require__(2);

$(window).on('load', function () {
	setTimeout(function () {
		$('.loading').addClass('is--hide');
	}, 1000);
	setTimeout(function () {
		inview();
		if (ua('iphone') || ua('android')) {} else {
			//playYt($('body').data('ytid01'), 'movie01', 1);
			playYt($('body').data('ytid02'), 'movie02', 1);
		}
	}, 1500);
	var count = 2;
	setInterval(function () {
		$('.slider--top li').removeClass('is--active');
		$('.slider--top li:nth-of-type(' + count + ')').addClass('is--active');
		if (count == 3) {
			count = 1;
		} else {
			count++;
		}
	}, 5000);
});

$(function () {
	$(window).on('scroll', function () {
		inview();
	});
	$(document).on('click', '.link--scroll', function (e) {
		e.preventDefault();
		$('html,body').animate({ scrollTop: $($(this).attr('href')).offset().top - 65 }, 'swing');
	});
	$(document).on('click', '.menu-trigger', function (e) {
		e.preventDefault();
		$(this).toggleClass('is--active');
		$('.gnav').toggleClass('is--active');
		$('.header .title').toggleClass('is--active');
	});
	$(window).on('scroll', function () {
		var top = $(window).scrollTop();

		if (top > 500) {
			$('.btn--pagetop').addClass('is--visible');
		} else if (top <= 500) {
			$('.btn--pagetop').removeClass('is--visible');
		}
	});

	$(document).on('click', '.btn--pagetop', function (e) {
		e.preventDefault();
		$('html,body').animate({ scrollTop: 0 }, 'swing');
	});
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.min.js